import { createI18n } from 'vue-i18n'
import { watch } from 'vue'
import { Locales, useLocaleStore } from './locale'
import { csRule } from './rules/cs'
import { messageCompiler } from './messageCompiler'

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: useLocaleStore.value,
  fallbackLocale: 'en',
  fallbackFormat: true,
  missingWarn: false,
  fallbackWarn: false,
  messageCompiler,
  pluralRules: {
    cs: csRule,
    sk: csRule,
  },
})

const $t = i18n.global.t

// Sync <html> lang attribute with selected locale by user
if (typeof document !== 'undefined') {
  const initialLocale = i18n.global.locale.value
  document.documentElement.setAttribute('lang', initialLocale)

  watch(
    () => i18n.global.locale.value,
    (newLocale) => {
      document.documentElement.setAttribute('lang', newLocale)
    },
  )
}

type LocaleManagerOptions = {
  reloadOnChange?: boolean
}

const createLocaleManager = (options: LocaleManagerOptions = {}) => ({
  setLocale(locale: Locales): void {
    useLocale().set(locale)

    if (options.reloadOnChange) {
      window.location.reload()
    }
  },
})

const useLocale = () => {
  const set = (locale: Locales): void => {
    i18n.global.locale.value = locale
    useLocaleStore.value = locale
  }

  const get = (): Locales => {
    return useLocaleStore.value
  }

  const setMessages = (messages: Record<string, object>): void => {
    Object.entries(messages).forEach(([localeKey, messages]) => {
      i18n.global.setLocaleMessage(localeKey, messages)
    })
  }

  return { set, get, setMessages }
}

export { useLocale, createLocaleManager, i18n, $t, Locales }
